import {match} from 'ts-pattern';

import {isNonEmptyArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';

const getOwnershipRoleLabel = (role: string) =>
  match(role)
    .with('OPERATOR', () => i18n.t('entity.ownership.label.vehicleOperator'))
    .with('OWNER', () => i18n.t('entity.ownership.label.vehicleOwner'))
    .with('USER', () => i18n.t('entity.ownership.label.vehicleUser'))
    .with('MANAGER', () => i18n.t('entity.ownership.label.vehicleManager'))
    .with('INVOICE', () => i18n.t('entity.ownership.label.defaultRecepient'))
    .otherwise(() => role);

export function getCustomNoticeOwnershipRolesLabel(roles: string[]) {
  if (!isNonEmptyArray(roles)) {
    return i18n.t('entity.customer.labels.ownership');
  }

  return roles.map(getOwnershipRoleLabel).join(', ');
}
